import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const SignInComponent = React.lazy(() => import("../Components/RootComponents/SignInComponent"));
const SignInPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <SignInComponent />
      </Suspense>
    </Fragment>
  );
};

export default SignInPage;
